import * as actionTypes from "../actions/types";
import axios from "../../axios";

export const openMainModalDashboard = (config) => {
  return {
    type: actionTypes.OPEN_MAIN_MODAL,
    payload: config,
  };
};

export const setPreviousLocation = (location) => {
  return {
    type: actionTypes.SET_PREVIOUS_LOCATION,
    payload: location,
  }
}

export const closeTutorialModal = () => {
  return {
    type: actionTypes.CLOSE_TUTORIAL_MODAL,
  };
};

export const openTutorialModal = () => {
  return {
    type: actionTypes.OPEN_TUTORIAL_MODAL,
  };
};

export const setTutorialStep = (step) => {
  return {
    type: actionTypes.SET_TUTORIAL_STEP,
    payload: step,
  };
};

export const setTutorialCompleted = () => {
  return {
    type: actionTypes.SET_TUTORIAL_COMPLETED,
  };
};

export const resetTutorial = () => {
  return {
    type: actionTypes.RESET_TUTORIAL,
  };
};

export const skipTutorial = () => {
  return {
    type: actionTypes.SKIP_TUTORIAL,
  };
};

export const resetRecentPost = () => {
  return {
    type: actionTypes.RECENT_POST,
    payload: [],
  };
};

//Acciones para Sección Que Pasa en Edify?

//Obtener total de usuarios 

export const getTotalUsers = () => {
  let tipoUrl = `/user/allUsers`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_TOTAL_USERS,
          payload: res.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

//obtener los últimos usuarios registrados

export const getLastNewUsers = () => {
  let tipoUrl = `/user/lastUsers`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_LAST_NEW_USERS,
          payload: res.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

//Obtener total de obras públicas

export const getTotalPublicProjects = () => {
  let tipoUrl = `proyecto/allProjects?type=PUBLIC`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        const totalPublicProjects = res.data.length;
        const lastPublicProject = res.data[res.data.length - 1];
        dispatch({
          type: actionTypes.GET_TOTAL_PUBLIC_PROJECTS,
          payload: { totalPublicProjects, lastPublicProject },
        });
      })
      .catch((err) => { });
  };
};

//Obtener total de obras privadas

export const getTotalPrivateProjects = () => {
  let tipoUrl = `proyecto/allProjects?type=PRIVATE`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_TOTAL_PRIVATE_PROJECTS,
          payload: res.data,
        });
      })
      .catch((err) => {
        console.log(err)
       });
  };
};

//Obtener total de cotizaciones públicas

export const getTotalPublicQuotations = () => {
  let tipoUrl = `quotation/allQuotations?type=PUBLIC`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        const totalPublicQuotations = res.data[1];
        const lastPublicQuotation = res.data[0][res.data[0].length - 1];
        dispatch({
          type: actionTypes.GET_TOTAL_PUBLIC_QUOTATIONS,
          payload: { totalPublicQuotations, lastPublicQuotation },
        });
      })
      .catch((err) => { });
  };
};

//Obtener total de Adjudicaciónes en el último año
export const getTotalAdjudications = () => {
  let tipoUrl = `adjudicados/get/getByFilter?type=PUBLIC&order=DESC&page=1&take=10`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        const totalAdjudications = res.data.itemCount;
        const lastAdjudicatedProject = res.data.entities[0];
        dispatch({
          type: actionTypes.GET_TOTAL_ADJUDICATED_PROJECTS,
          payload: totalAdjudications,
        });
        dispatch({
          type: actionTypes.GET_LAST_ADJUDICATED_PROJECT,
          payload: lastAdjudicatedProject,
        });
      })
      .catch((err) => {
        console.log(err)
      });
  }
}

//Obtener la última obra pública adjudicada
export const getLastAdjudicatedProject = () => {
  let tipoUrl = `adjudicados/lastAdjudicated `;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        const lastAdjudicatedProject = res.data[0];
        dispatch({
          type: actionTypes.GET_LAST_ADJUDICATED_PROJECT,
          payload: lastAdjudicatedProject,
        });
      })
      .catch((err) => {
        console.log(err)
      });
  }
}


//Obtener total de cotizaciones públicas el ultimo mes

export const getTotalNewPublicQuotations = () => {
  let tipoUrl = `quotation/lastQuotations?type=PUBLIC`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        const totalNewPublicQuotations = res.data.length;
        dispatch({
          type: actionTypes.GET_TOTAL_NEW_PUBLIC_QUOTATIONS,
          payload: totalNewPublicQuotations,
        });
      })
      .catch((err) => { });
  };
};

//Obtener total de cotizaciones privadas

export const getTotalPrivateQuotations = () => {
  let tipoUrl = `quotation/allQuotations?type=PRIVATE`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {

        dispatch({
          type: actionTypes.GET_TOTAL_PRIVATE_QUOTATIONS,
          payload: res.data[0],
        });
      })
      .catch((err) => {
        console.log(err)
      });
  };
};

export const fetchAdminDashboardStats = () => {
  return (dispatch) => {
    dispatch(getTotalUsers());
    dispatch(getTotalPublicProjects());
    dispatch(getTotalPrivateProjects());
    dispatch(getTotalPublicQuotations());
    dispatch(getTotalPrivateQuotations());
  };
};

//Obtener total de cotizaciones privadas el ultimo mes

export const getTotalNewPrivateQuotations = () => {
  let tipoUrl = `quotation/lastQuotations?type=PRIVATE`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        const totalNewPrivateQuotations = res.data.length;
        dispatch({
          type: actionTypes.GET_TOTAL_NEW_PRIVATE_QUOTATIONS,
          payload: totalNewPrivateQuotations,
        });
      })
      .catch((err) => { });
  };
};

//Obtener el resúmen de actividades de un usuario
export const getUserActivitySummary = (userId) => {
  let tipoUrl = `/user/activity/${userId}`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_USER_ACTIVITY_SUMMARY,
          payload: res.data,
        });
      })
      .catch((err) => {
        console.log(err)
      }
      );
  };
};

export const getAllPortfolios = () => {
  let tipoUrl = `/portfolio/getAll`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_ALL_PORTFOLIOS,
          payload: res.data,
        });
      })
      .catch((err) => {
        console.log(err)
      });
  };
};

export const refetchPortfolios = () => (dispatch) => dispatch(getAllPortfolios());


export const generateProfilePostText = () => {
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    return axios
      .get("/chatbot/generate/profile-post", bearerToken)
      .then((res) => res.data?.data?.response ?? '')
      .catch((err) => {
        throw err;
      });
  };
};

//Filtrador de proyectos públicos
export const filterPublicProjects = (searchParams, page, take) => {

  let orderParam = `${searchParams.sort ? searchParams.sort : "DESC"}`;
  let nameParam = `${searchParams.asociatedWords ? "&nombre=" + searchParams.asociatedWords : ""}`;
  let zoneParam = `${searchParams.zone ? "&zone=" + searchParams.zone : ""}`;
  let minAmountParam = `${searchParams.minAmount ? "&montoMin=" + searchParams.minAmount : ""}`;
  let maxAmountParam = `${searchParams.maxAmount ? "&montoMax=" + searchParams.maxAmount : ""}`;
  let currencyParam = `${searchParams.currency ? "&currency=" + searchParams.currency : ""}`;
  let jurisdictionParam = `${searchParams.jurisdiction ? "&jurisdiccion=" + searchParams.jurisdiction : ""}`;
  let organismParam = `${searchParams.organism ? "&organismo=" + searchParams.organism : ""}`;
  let obra_type = `${searchParams.workType ? "&obra_type=" + searchParams.workType : ""}`;
  let sinceParam = `${searchParams.dateRange?.dateFrom ? "&dateFrom=" + searchParams.dateRange.dateFrom : ""}`;
  let untilParam = `${searchParams.dateRange?.dateTo ? "&dateTo=" + searchParams.dateRange.dateTo : ""}`;
  let tipoUrl = searchParams.projectType === "Adjudicadas" ? `/adjudicados/get/getByFilter?type=PUBLIC&order=${orderParam}&page=${page}&take=${take}`
    : `/proyecto/get/getPublicsByFilter?type=PUBLIC&order=${orderParam}&page=${page}&take=${take}`;

  let sendURL = `${tipoUrl}${nameParam}${zoneParam}${minAmountParam}${maxAmountParam}${currencyParam}${jurisdictionParam}${organismParam}${obra_type}${sinceParam}${untilParam}`;

  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_DASHBOARD_PROJECTS_LOADING,
      payload: true,
    });
    axios
      .get(sendURL, bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_DASHBOARD_PROJECTS,
          payload: {
            data: res.data.entities,
            itemCount: res?.data?.itemCount,
            take: res?.data?.take,
          }
        });
      })
      .catch((err) => {
        console.log(err)
        dispatch({
          type: actionTypes.GET_DASHBOARD_PROJECTS_LOADING,
          payload: false,
        });
      });
  };
};

export const filterQuotations = (searchParams, page, take) => {
  let orderParam = `${searchParams.sort ? searchParams.sort : "DESC"}`;
  let nameParam = `${searchParams.asociatedWords ? "&nombre=" + searchParams.asociatedWords : ""}`;
  let zoneParam = `${searchParams.zone ? "&zone=" + searchParams.zone : ""}`;
  let minAmountParam = searchParams.projectType === "Privadas" ? "" : `${searchParams.minAmount ? "&montoMin=" + searchParams.minAmount : ""}`;
  let maxAmountParam = searchParams.projectType === "Privadas" ? "" : `${searchParams.maxAmount ? "&montoMax=" + searchParams.maxAmount : ""}`;
  let currencyParam = `${searchParams.currency ? "&currency=" + searchParams.currency : ""}`;
  let jurisdictionParam = `${searchParams.jurisdiction ? "&jurisdiccion=" + searchParams.jurisdiction : ""}`;
  let organismParam = `${searchParams.organism ? "&organismo=" + searchParams.organism : ""}`;
  let obra_type = searchParams.projectType === "Privadas" ? `${searchParams.workType ? "&category=" + searchParams.workType : ""}`
    : `${searchParams.workType ? "&obra_type=" + searchParams.workType : ""}`;
  let sinceParam = `${searchParams.dateRange?.dateFrom ? "&dateFrom=" + searchParams.dateRange.dateFrom : ""}`;
  let untilParam = `${searchParams.dateRange?.dateTo ? "&dateTo=" + searchParams.dateRange.dateTo : ""}`;
  let tipoUrl = searchParams.projectType === "Privadas" ? `/quotation/getByFilter?type=PRIVATE&order=${orderParam}&page=${page}&take=${take}&active=true`
    : `/quotation/get/getPublicsByFilter?type=PUBLIC&order=${orderParam}&page=${page}&take=${take}&active=true`;

  let sendURL = `${tipoUrl}${nameParam}${zoneParam}${minAmountParam}${maxAmountParam}${currencyParam}${jurisdictionParam}${organismParam}${obra_type}${sinceParam}${untilParam}`;

  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_DASHBOARD_PROJECTS_LOADING,
      payload: true,
    });
    axios
      .get(sendURL, bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_QUOTATIONS_TYPE,
          payload: res.data,
          page,
          itemCount: res?.data?.itemCount,
          take: res?.data?.take,
        });
        dispatch({
          type: actionTypes.GET_DASHBOARD_PROJECTS_LOADING,
          payload: false,
        });
      })
      .catch((err) => {
        console.log(err)
        dispatch({
          type: actionTypes.GET_DASHBOARD_PROJECTS_LOADING,
          payload: false,
        });
      });
  };
};

export const filterPrivateProjects = (searchParams, page, take, clear) => {

  let orderParam = `${searchParams.sort ? searchParams.sort : "DESC"}`;
  let zoneParam = `${searchParams.zone ? "&ubicacion=" + searchParams.zone : ""}`;
  let workTypeParam = `${searchParams.workType ? "&subproyecto=" + searchParams.workType : ""}`;
  let sinceParam = `${searchParams.dateRange?.dateFrom ? "&dateFrom=" + searchParams.dateRange.dateFrom : ""}`;
  let untilParam = `${searchParams.dateRange?.dateTo ? "&dateTo=" + searchParams.dateRange.dateTo : ""}`;

  let tipoUrl = `/proyecto/get/getPrivatesByFilter?type=PRIVATE&order=${orderParam}&page=${page}&take=${take}`;

  let sendURL = clear ? `${tipoUrl}` : `${tipoUrl}${zoneParam}${workTypeParam}${sinceParam}${untilParam}`;

  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_DASHBOARD_PROJECTS_LOADING,
      payload: true,
    });
    axios
      .get(sendURL, bearerToken)
      .then((res) => {
        dispatch({
          type: actionTypes.GET_DASHBOARD_PROJECTS,
          payload: {
            data: res.data.entities,
            itemCount: res?.data?.itemCount,
            take: res?.data?.take,
          }
        });
        dispatch({
          type: actionTypes.GET_DASHBOARD_PROJECTS_LOADING,
          payload: false,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.GET_DASHBOARD_PROJECTS_LOADING,
          payload: false,
        });
      });
  };
};


//Ver Perfil Externo
const setProfileVisualizerData = (data) => {
  return {
    type: actionTypes.SET_PROFILE_VISUALIZER,
    payload: data,
  };
};

export const getProfileVisualizer = (id) => {
  let tipoUrl = `/user/data?userFind=${id}`;
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    dispatch({ type: actionTypes.START_LOADING });
    axios
      .get(tipoUrl, bearerToken)
      .then((res) => {
        dispatch(setProfileVisualizerData({ ...res.data, id: id }));
        dispatch({ type: actionTypes.END_LOADING });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: actionTypes.END_LOADING });
      });
  };
};

export const clearProjects = () => {
  return {
    type: actionTypes.CLEAR_PROJECTS,
  };
};





